import React from 'react';
import cn from 'classnames';

import styles from './JobSearch.module.scss';

export default function JobSearch(props) {
  return (
    <div
      style={{ '--src': `url(${require('assets/1ca13b6524e09d4cd88e5fa9553cb205.png')})` }}
      className={cn(styles.root, 'job-search')}>
      <div className={styles.flex_col}>
        <h1 className={styles.hero_title}>AI Job Search</h1>

        <div className={styles.content_box1}>
          <h3 className={styles.subtitle_box}>
            <input
              className={styles.subtitle}
              type={'text'}
              placeholder={`Are you ready to discover your ideal job with the assistance of our powerful AI?`}
            />
          </h3>
        </div>

        <div className={styles.flex_col__cell}>
          <button
            style={{ '--src': `url(${require('assets/4113fa164478c27777b67a00435db3ee.png')})` }}
            className={styles.btn}
            onClick={() => { window.open('/JobResults', '_self'); }}>
            <span className={styles.btn__text}>Start</span>
          </button>
        </div>
      </div>
    </div>
  );
}
